import React, { useState } from 'react';
import Validator, { ValidationTypes as V_Type } from 'react-form-supervalidator';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import CustomTextarea from 'Common/CustomTextArea';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import CustomInput from 'Common/CustomInput/CustomInput';
import CustomSelect from 'Common/CustomSelect/CustomSelect';
import { paidAmountValidator } from 'Utils/validators';


const PaymentRefundPopup = ({ paidAmount, onConfirm, required, onCancel, disableDraggable }) => {
    const UNIQUE_ID = "PaymentRefundPopup"
    const [Model, setModel] = useState({
        reason: "",
        amount: paidAmount,
        reasonNote: ""
    })
    const [MyvalidationModel, setMyvalidationModel] = useState({
        reasonError: null,
        amountError: null,
        reasonNoteError: null,
    });
    const dropdownOptions = [
        { value: 0, label: 'Duplicate' },
        { value: 1, label: 'Fraudulent' },
        { value: 2, label: 'Requested by customer' },
        { value: 3, label: 'Other' },
        // Add more options as needed
    ];


    const handleChange = (e) => {
        const { name, value } = e.target;

        setModel((prevModel) => ({
            ...prevModel,
            [name]: value,
        }));
    };

    const customNoteHandler = (data) => {
        if (Model.reason === "3") {
            if (Model.reasonNote === "") {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };
    const handleCancle = () => {
        setModel((prev) => ({
            ...prev,
            reason: "",
            amount: "",
            reasonNote: ""
        }))
        onCancel(true)
    }

    const setValidation = () => {
        let myValidationObj = {
            ...MyvalidationModel,
            reasonError: Validator(Model.reason, [V_Type.required], ['Reason is required']),
            amountError: Validator(Model.amount, [V_Type.required, paidAmountValidator], ["Amount is required", "Amount must be less than Paid Amount"]),
            reasonNoterror: Validator(Model.reasonNote, [customNoteHandler], ["Reason Note is required"]),
        };
        setMyvalidationModel(myValidationObj);
        return Validator(myValidationObj, V_Type.NullCheck);
    };

    const handleSave = () => {
        if (!required || !setValidation()) {
            onConfirm(Model);
        }
    };

    return (
        <ReactPortal wrapperId={UNIQUE_ID}>
            <div
                data-te-modal-init
                className="flex fixed inset-0 z-10 justify-center items-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${UNIQUE_ID}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-full min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={UNIQUE_ID}
                            className="flex justify-between items-center p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            Refund Payment
                            <button onClick={handleCancle} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>
                        <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
                            <p className="text-[#2c3e50]   max-w-[400px] text-sm font-semibold mt-2  w-full">
                                Refunds take 5-10 days to appear on to customer's statement. Stripe fees for the original payment won't be returned, but there are no additional fees for the refund.
                                <a href={`https://support.stripe.com/questions/understanding-fees-for-refunded-payments`} target='_blank' className='ml-1 text-blue-700 cursor-pointer hover:underline' rel="noreferrer" >Learn more.</a>
                            </p>
                            <div className='grid grid-cols-12 gap-4'>
                                <div className='col-span-6'>
                                    <CustomInput
                                        name={"amount"}
                                        value={Model.amount}
                                        onChange={handleChange}
                                        label="Refund"
                                        maxFloat={1}
                                        isNumeric
                                        isFloat
                                        required
                                        // SuffixIconClass={"left-[.55rem] "}
                                        // prefixImg={"/img/patientBalance.svg"}
                                        type="text"
                                        placeholder=""
                                    />
                                    {MyvalidationModel.amountError}
                                </div>
                                <div className='col-span-6'>
                                    <CustomSelect
                                        name={"reason"}
                                        // extraClass={"w-64"}
                                        required
                                        label="Reason"
                                        onChange={handleChange}

                                    >
                                        <option value="">Please Select</option>
                                        {dropdownOptions.map(option => (
                                            <option key={option.key} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </CustomSelect>
                                    {MyvalidationModel.reasonError}
                                </div>
                                <div className='col-span-12'>
                                    <CustomTextarea placeholder="Add a reason for this refund." value={Model.reasonNote} name="reasonNote" onChange={handleChange} rows="5" extraClass={`border-1 border-primaryColor outline-none mt-1`} />
                                    {MyvalidationModel.reasonNoterror}
                                </div>

                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap gap-2 justify-end items-center p-5">
                            <CustomButtonNew label={"Cancel"} variant={"outline"} onClick={handleCancle} />
                            <CustomButtonNew label="Refund" onClick={handleSave} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    );
};

export default PaymentRefundPopup;
